import styled from "styled-components";

const TableDashboardStyle = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");
  
  * {
    margin: 0;
    box-sizing: border-box;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif !important;
  }

  /* ============================================
     GLOBAL TYPOGRAPHY - Apply to header section too
     ============================================ */

  select, input, button, label, span, p, a, div {
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif !important;
  }

  /* ============================================
     HEADER SECTION - MODERN UNIFIED DESIGN
     ============================================ */

  .limiterHeader {
    background: white;
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 20px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    position: relative;
    z-index: 50;
  }


  .colHeader {
    padding: 8px;
  }

  /* Search with Refresh container */
  .search-with-refresh {
    display: flex;
    align-items: stretch;
    gap: 10px;
    width: 100%;
  }

  .search-with-refresh > div,
  .search-with-refresh > form {
    flex: 1;
  }

  .search-with-refresh .btn-refresh {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #e5e7eb;
    background: white;
    border-radius: 12px;
    color: #6b7280;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 16px;
  }

  .search-with-refresh .btn-refresh:hover {
    background: #7367f0;
    border-color: #7367f0;
    color: white;
    transform: rotate(180deg);
  }

  /* Fix Plugin Selector Dropdown Overflow */
  .limiterHeader select {
    width: 100%;
    padding: 14px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    color: #111827;
    background: white;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 16px center;
    padding-right: 40px;
    cursor: pointer;
    transition: all 0.2s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .limiterHeader select:focus {
    outline: none;
    border-color: #7367f0;
    box-shadow: 0 0 0 4px rgba(115, 103, 240, 0.1);
  }

  /* Input Fields */
  .limiterHeader input[type="text"]:not(.search-input),
  .limiterHeader .form-control:not(.search-input) {
    width: 100%;
    padding: 14px 16px;
    border: 2px solid #e5e7eb !important;
    border-radius: 12px !important;
    font-size: 14px !important;
    font-weight: 500;
    color: #111827;
    background: white !important;
    transition: all 0.2s ease;
    box-shadow: none !important;
  }

  .limiterHeader input[type="text"]:not(.search-input):focus,
  .limiterHeader .form-control:not(.search-input):focus {
    outline: none;
    border-color: #7367f0 !important;
    box-shadow: 0 0 0 4px rgba(115, 103, 240, 0.1) !important;
  }

  /* Input Group (Search) */
  .limiterHeader .input-group {
    border-radius: 12px;
    overflow: hidden;
    border: 2px solid #e5e7eb;
    background: white;
    transition: all 0.2s ease;
  }

  .limiterHeader .input-group:focus-within {
    border-color: #7367f0;
    box-shadow: 0 0 0 4px rgba(115, 103, 240, 0.1);
  }

  .limiterHeader .input-group input,
  .limiterHeader .input-group .form-control {
    border: none !important;
    box-shadow: none !important;
    padding: 14px 16px;
    font-size: 14px;
    border-radius: 0 !important;
  }

  .limiterHeader .input-group button,
  .limiterHeader .input-group .btn,
  .limiterHeader .input-group .input-group-text {
    background: #7367f0 !important;
    border: none !important;
    padding: 0 18px;
    color: white !important;
    border-radius: 0 !important;
  }

  /* Dropdown Buttons - Modern Style */
  .limiterHeader .dropdown,
  .limiterHeader .dropdown-toggle,
  .limiterHeader .btn-secondary {
    width: 100%;
  }

  .limiterHeader .dropdown-toggle,
  .limiterHeader .btn-secondary,
  .limiterHeader button.btn {
    width: 100%;
    padding: 14px 20px !important;
    border-radius: 12px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    border: 2px solid transparent !important;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  /* Green Options Button (Opciones) */
  .limiterHeader .btn-secondary,
  .limiterHeader .dropdown-toggle.btn-secondary {
    background: #7367f0 !important;
    color: white !important;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.25);
  }

  .limiterHeader .btn-secondary:hover {
    background: #5a4fcf !important;
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(115, 103, 240, 0.35);
  }

  /* Filter Button */
  .limiterHeader .dropdown-toggle:not(.btn-secondary) {
    background: white !important;
    color: #374151 !important;
    border: 2px solid #e5e7eb !important;
  }

  .limiterHeader .dropdown-toggle:not(.btn-secondary):hover {
    border-color: #7367f0 !important;
    color: #7367f0 !important;
  }

  /* Dropdown Menu */
  .limiterHeader .dropdown-menu {
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    padding: 8px;
    margin-top: 8px;
  }

  .limiterHeader .dropdown-item {
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.15s ease;
  }

  .limiterHeader .dropdown-item:hover {
    background: #f8f7ff;
    color: #7367f0;
  }

  /* Tags/Badges */
  .limiterHeader .badge,
  .limiterHeader .tag {
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  /* Actions Content Section */
  .ActionsContent {
    background: white;
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 20px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    position: relative;
    z-index: 50;
  }


  /* ============================================
     MAIN TABLE CONTAINER
     ============================================ */

  .container-table100 {
    width: 100%;
    padding: 0;
  }

  .wrap-table100 {
    width: 100%;
  }

  .table100 {
    overflow-x: auto;
    background: white;
    border-radius: 16px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  /* Main Table - FIXED LAYOUT */
  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    table-layout: fixed;
  }

  /* Table Header */
  thead tr {
    background: #fafafa;
    border-bottom: 2px solid #e5e7eb;
  }

  thead th {
    padding: 18px 16px;
    font-size: 11px;
    font-weight: 700;
    color: #7367f0;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    text-align: left;
    white-space: nowrap;
  }

  /* FIXED COLUMN WIDTHS */
  thead th:nth-child(1),
  tbody td:nth-child(1) {
    width: 90px;
  }

  thead th:nth-child(2),
  tbody td:nth-child(2) {
    width: 35%;
  }

  thead th:nth-child(3),
  tbody td:nth-child(3),
  thead th:nth-child(4),
  tbody td:nth-child(4) {
    width: 20%;
  }

  thead th:nth-child(5),
  tbody td:nth-child(5) {
    width: 140px;
  }

  /* Table Body - LARGER ROWS */
  tbody tr {
    border-bottom: 1px solid #f3f4f6;
    transition: all 0.15s ease;
  }

  tbody tr:last-child {
    border-bottom: none;
  }

  tbody tr:hover {
    background: #fafafa;
  }

  tbody td {
    padding: 20px 16px;
    font-size: 14px;
    color: #374151;
    vertical-align: middle;
  }

  /* Product Image Column */
  .column-image {
    padding-left: 16px;
    vertical-align: middle;
  }

  .product-image {
    width: 64px;
    height: 64px;
    border-radius: 10px;
    object-fit: cover;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
  }

  .image-placeholder {
    width: 64px;
    height: 64px;
    border-radius: 10px;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e5e7eb;
  }

  .image-placeholder svg {
    width: 24px;
    height: 24px;
    color: #9ca3af;
  }

  /* Product Title Column */
  .column-title {
  }

  .product-title {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
    text-decoration: none;
    display: block;
    line-height: 1.5;
    transition: color 0.15s ease;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .product-title:hover {
    color: #7367f0;
  }

  .product-brand {
    font-size: 12px;
    color: #6b7280;
    margin-top: 3px;
    font-style: italic;
  }

  /* Barcode & SKU Columns */
  .column-codes {
  }

  .code-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .code-item {
    font-family: "SF Mono", "Monaco", "Inconsolata", "Fira Mono", monospace !important;
    font-size: 12px;
    padding: 5px 8px;
    border-radius: 6px;
    display: inline-block;
    width: fit-content;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.3;
  }

  /* Primary code (first one) - Purple */
  .code-item.primary {
    font-weight: 600;
    background: #f0f0ff;
    border: 1px solid #d8d5f7;
    color: #5a4fcf;
  }

  /* Secondary codes (rest) - Gray */
  .code-item.secondary {
    font-weight: 400;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    color: #6b7280;
  }

  /* Barcode - All uniform gray */
  .code-item.barcode {
    font-weight: 500;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    color: #374151;
  }


  /* Synced SKU - Green tint */
  .code-item.synced {
    background: #ecfdf5 !important;
    border-color: #a7f3d0 !important;
    color: #047857 !important;
  }

  /* Partially synced SKU - Yellow tint */
  .code-item.partial {
    background: #fffbeb !important;
    border-color: #fde68a !important;
    color: #b45309 !important;
  }

  /* Unsynced SKU - Red tint */
  .code-item.unsynced {
    background: #fef2f2 !important;
    border-color: #fecaca !important;
    color: #dc2626 !important;
  }

  /* No data placeholder */
  .code-item.no-data {
    background: #f9fafb;
    border: 1px dashed #d1d5db;
    color: #9ca3af;
    font-style: italic;
    font-family: "Inter", sans-serif !important;
  }

  /* Status Column */
  .column-status {
  }

  .status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }

  .status-badge.synced {
    background: #ecfdf5;
    color: #047857;
  }

  .status-badge.partial {
    background: #fffbeb;
    color: #b45309;
  }

  .status-badge.unlinked {
    background: #fef2f2;
    color: #dc2626;
  }

  .status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }

  .status-badge.synced .status-dot {
    background: #10b981;
  }

  .status-badge.partial .status-dot {
    background: #f59e0b;
  }

  .status-badge.unlinked .status-dot {
    background: #ef4444;
  }

  /* ML Status Column */
  .column-ml-status {
  }

  .ml-status-badge {
    display: inline-flex;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
  }

  .ml-status-badge.active {
    background: #ecfdf5;
    color: #047857;
  }

  .ml-status-badge.paused {
    background: #fffbeb;
    color: #b45309;
  }

  /* Actions Column */
  .column-actions {
    text-align: center;
    vertical-align: middle;
  }

  /* ============================================
     BUTTONS
     ============================================ */

  .btn-refresh {
    width: 40px;
    height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #e5e7eb;
    background: white;
    border-radius: 10px;
    color: #6b7280;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .btn-refresh:hover {
    background: #7367f0;
    border-color: #7367f0;
    color: white;
    transform: rotate(180deg);
  }

  .btn-refresh:focus {
    outline: none;
    box-shadow: 0 0 0 4px rgba(115, 103, 240, 0.15);
  }

  .btn-publish-in-another-store {
    background: #7367f0;
    color: white;
    border: none;
    border-radius: 10px;
    padding: 12px 20px;
    font-size: 14px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.25);
  }

  .btn-publish-in-another-store:hover {
    background: #5a4fcf;
    transform: translateY(-1px);
  }

  .btn-publish-in-another-store-clear {
    width: 38px;
    height: 38px;
    background: #ef4444;
    color: white;
    border: none;
    border-radius: 50%;
    margin-left: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .btn-publish-in-another-store-clear:hover {
    background: #dc2626;
    transform: scale(1.05);
  }

  /* ============================================
     CHECKBOX STYLES
     ============================================ */

  .cbx {
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
  }

  .cbx span {
    display: inline-block;
    vertical-align: middle;
  }

  .cbx span:first-child {
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 6px;
    border: 2px solid #d1d5db;
    transition: all 0.2s ease;
    background: white;
  }

  .cbx span:first-child svg {
    position: absolute;
    top: 4px;
    left: 3px;
    fill: none;
    stroke: #ffffff;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 16px;
    stroke-dashoffset: 16px;
    transition: all 0.3s ease;
    transition-delay: 0.1s;
  }

  .cbx:hover span:first-child {
    border-color: #7367f0;
  }

  .inp-cbx:checked + .cbx span:first-child {
    background: #7367f0;
    border-color: #7367f0;
  }

  .inp-cbx:checked + .cbx span:first-child svg {
    stroke-dashoffset: 0;
  }

  .cbt-btn {
    padding: 8px 14px;
    background: #7367f0;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-left: 8px;
  }

  .cbt-btn:hover {
    background: #5a4fcf;
  }

  /* ============================================
     LOADING & EMPTY STATES
     ============================================ */

  tbody tr td[colspan] {
    text-align: center;
    padding: 60px 20px;
    color: #6b7280;
    font-size: 15px;
  }

  /* ============================================
     RESPONSIVE DESIGN
     ============================================ */

  @media screen and (max-width: 1200px) {
    table {
      table-layout: auto;
    }
  }

  @media screen and (max-width: 992px) {
    .limiterHeader,
    .ActionsContent {
      padding: 16px;
      border-radius: 12px;
    }

    .search-with-refresh {
      flex-direction: column;
    }

    .search-with-refresh .btn-refresh {
      width: 100%;
      margin-top: 8px;
    }

    table {
      display: block;
      table-layout: auto;
    }

    thead {
      display: none;
    }

    tbody tr {
      display: block;
      padding: 16px;
      margin-bottom: 12px;
      background: white;
      border-radius: 12px;
      border: 1px solid #e5e7eb;
    }

    tbody td {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 10px 0;
      border-bottom: 1px solid #f3f4f6;
      width: 100% !important;
    }

    tbody td:last-child {
      border-bottom: none;
    }

    tbody td::before {
      content: attr(data-label);
      font-weight: 600;
      font-size: 11px;
      color: #7367f0;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
  }

  @media (max-width: 576px) {
    .limiterHeader,
    .ActionsContent,
    .table100 {
      border-radius: 10px;
    }

    .limiterHeader,
    .ActionsContent {
      padding: 12px;
    }
  }
`;

export default TableDashboardStyle;
